//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const GlobalFunc = require('@/tbs/util/GlobalFunc')
const ClassFunc = require('@/tbs/util/ClassFunc')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_MatchTeamMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_MatchTeamMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_MatchTeamMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    handleCreationComplete: function() {
        // console.log('handleCreationComplete')
        let matchGroupId
        const matchId = this._bridge.getRouteQuery('matchId')
        if (this._bridge.isList()) {
            matchGroupId = this._bridge.getRouteParam('id')
            this.target().matchGroupId = matchGroupId
            this.target().matchId = matchId
        }
        else {
            matchGroupId = this._bridge.getRouteQuery('matchGroupId')
            this.target().team = {
                matchGroupId: matchGroupId
            }
        }
        
        if (!this._bridge.isCreate()) {
            if (this._bridge.isList()) {
                this.creationComplete({parameters: {
                    matchId: matchId,
                    matchGroupId: matchGroupId
                }})
            }
            else {
                this.creationComplete({parameters: {
                    matchId: matchGroupId
                }})
            }
        }
    },
    handleDataLoaded() {
        console.log('handleDataLoaded')
        if (this._bridge.isList()) {
            let tab = this._bridge.getRouteQuery('tab')
            console.log('@tab', tab)
            tab = tab || '0'
            const self = this
            GlobalFunc.delayExecute(self, function() {
                self.target().selectedTabIndex = Number(tab)
                self.loadGroupList()
                if (tab === '1') {
                    self.loadGroupTeamList()
                }
            }, 0)
        }
    },
    handleCustomizedEvent(event) {
        console.log('handleCustomizedEvent', event)
        if (event.type == 'load') {
            // update the router url with the given round seq
            this._bridge.replaceQuery({tab: event.data.index, matchId: this._bridge.getRouteQuery('matchId')})
            if (event.data.index === 1) {
                this.loadGroupTeamList()
            }
        }
        else if (event.type == 'reset') {
            this.resetGroupTeamList(event.data)
        }
        else {
            return true
        }
    },
    handleRouteBack: function() {
        if (this._bridge.getRouteName() == 'OrgListMatchTeam') {
            this._bridge.goToScene('OrgManageMatch', {id: this._bridge.getRouteQuery('matchId')})
        }
        else {
            this._bridge.back()
        }
    },
    handleRemoveService: function() {
        this._bridge.goToScene('OrgListMatchTeam', {id: this._bridge.getRouteQuery('matchGroupId')}, {matchId: this._bridge.getRouteQuery('matchId')})
    },
    loadGroupList: function() {
        const self = this
        const matchGroupId = self._bridge.getRouteParam('id')
        const roundList = self.target().team.roundList
        if (roundList && roundList.length > 0) {
            const stageId = roundList[0].stageId
            self.loadViewObjectData(self.convertor(), {matchGroupId: matchGroupId, stageId: stageId}, function(viewData) {
                console.log('@viewData', viewData)
                self.target().groupList = viewData
            }, 'getGroupList')
        }
    },
    loadGroupTeamList: function() {
        const self = this
        const matchGroupId = self._bridge.getRouteParam('id')
        const roundList = self.target().team.roundList
        if (roundList && roundList.length > 0) {
            const stageId = roundList[0].stageId
            self.loadViewObjectData(self.convertor(), {matchGroupId: matchGroupId, stageId: stageId}, function(viewData) {
                console.log('@viewData', viewData)
                self.target().groupTeamList = viewData
            }, 'getGroupTeamList')
        }
    },
    resetGroupTeamList: function(data) {
        const self = this
        self.commitViewObjectData(self.convertor(), data, function(e) {
            console.log('@resetGroupTeamList', e)
            self.loadGroupTeamList()
        }, 'resetGroupTeamList')
    }
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_MatchTeamMediator, BaseMediator);

module.exports = tbs_controller_MatchTeamMediator